export default __webpack_public_path__ + "static/media/Purple-Exec-Corp.0b1f2069.svg";